/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: fontawesome.ts
 * Class: fontawesome.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import {
  faAngleDown,
  faAngleUp,
  faArrowLeft,
  faArrowRight,
  faCalendarAlt,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faClock,
  faCreditCard,
  faExclamationCircle,
  faExclamationTriangle,
  faHeartBroken,
  faInfoCircle,
  faLocationArrow,
  faLongArrowAltLeft,
  faLongArrowAltRight,
  faMapMarkerAlt,
  faPhoneAlt,
  faPlayCircle,
  faSearch,
  faSort,
  faSortDown,
  faSortUp,
  faSpinner,
  faStar,
  faTimes,
  faWallet,
} from '@fortawesome/free-solid-svg-icons';

import { faCheckSquare, faCircle } from '@fortawesome/free-regular-svg-icons';

import { faPlus, faTimes as faRegularTimes } from '@fortawesome/pro-regular-svg-icons';

const icons = {
  faCheckSquare,
  faPhoneAlt,
  faLocationArrow,
  faMapMarkerAlt,
  faLongArrowAltRight,
  faLongArrowAltLeft,
  faPlus,
  faRegularTimes,
  faTimes,
  faCircle,
  faCreditCard,
  faArrowLeft,
  faArrowRight,
  faAngleDown,
  faChevronUp,
  faAngleUp,
  faStar,
  faSpinner,
  faInfoCircle,
  faSort,
  faSortUp,
  faSortDown,
  faCheck,
  faCalendarAlt,
  faExclamationTriangle,
  faWallet,
  faClock,
  faExclamationCircle,
  faSearch,
  faPlayCircle,
  faChevronRight,
  faChevronLeft,
  faHeartBroken,
};

export default icons;
